import httpManager from "@/app/shared/utils/httpManager";

export async function updateStrategyData(strategyId, { turnedOn, withoutUsers=false }) {
  const response = await httpManager.put(`/strategies/${strategyId}/`, {
    turned_on: turnedOn,
    without_users: withoutUsers
  });
  return response.data;
}
